import * as types from '../actiontypes';

export function addOverWriteDocument(document) {
	return {
		type: types.ADD_DUPLICATE_DOCUMENT,
		meta: {
			document: document
		}
	};
}

export function clearDuplicateDocuments(payload) {
	return {
		type: types.CLEAR_DUPLICATE_DOCUMENTS,
		payload
	};
}

export function removeTaskDocument(document) {
	return {
		type: types.REMOVE_TASK_DOCUMENT,
		documentName: document.documentName,
		parentName: document.payload.parentName,
		entityUid: document.payload.entityUid,
		documentId: document.documentId
		//TODO Send meta like shown below and remove sending parentName directly in action
		// meta: {
		// 	docHelper: {
		// 		payload: {
		// 			parentName: document.payload.parentName
		// 		}
		// 	}
		// }
	};
}

export function selectDocumentOverwrite(relatedEntityId, documentId, documentName, isOverWrite, parentName) {
	return {
		type: types.SELECT_DOCUMENT_OVERWRITE,
		relatedEntityId,
		parentName,
		meta: {
			documentId,
			documentName,
			isOverWrite: isOverWrite
		}
	};
}
